"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
var angular = require("angular");
var promise_tracking_chart_1 = require("./promise-tracking.chart");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
var promise_tracking_logic_1 = require("./promise-tracking.logic");
var PromiseTrackingComponent = /** @class */ (function (_super) {
    __extends(PromiseTrackingComponent, _super);
    function PromiseTrackingComponent($scope, $timeout) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'PromiseTracking') || this;
        var ctrl = _this;
        $scope.$on('command:ADD_PROMISE', function (event, args) {
            _this.init(ctrl, event, args);
        });
        $scope.$on('command:PROMISE_TRACKING', function (event, args) {
            _this.init(ctrl, event, args);
        });
        $scope.$on('export:csv', function (event, args, callback) {
            var csv = promise_tracking_logic_1.PromiseTrackingTable.downloadCsv(ctrl.tableData, args.filename, args.csvFormat, args.skipSave || false);
            if (callback) {
                callback(csv);
            }
        });
        return _this;
    }
    PromiseTrackingComponent.prototype.init = function (ctrl, event, args) {
        var _a, _b, _c, _d;
        ctrl.initComponent(event, args);
        var isAdmin = ctrl.smartorgApi.protocols.credentials.isAdmin;
        if (isAdmin) {
            ctrl.addPromiseConfigToMenu();
        }
        var config = args.config.data.data[0];
        var colHeaders = [];
        var years = [];
        var mainTableData = [];
        var siblingTableData = [];
        if (!config['isGroupBy']) {
            if (config.mainRows.length > 0) {
                _a = promise_tracking_logic_1.PromiseTrackingTable.makeColHeader(config.mainRows), colHeaders = _a[0], years = _a[1];
                mainTableData.push(promise_tracking_logic_1.PromiseTrackingTable.makeTableData(config.mainRows, args.nodeName));
            }
            else if (config.siblingRows.length > 0) {
                _b = promise_tracking_logic_1.PromiseTrackingTable.makeColHeader(config.siblingRows), colHeaders = _b[0], years = _b[1];
            }
            else {
                _c = promise_tracking_logic_1.PromiseTrackingTable.makeColHeader(config.forecastRows), colHeaders = _c[0], years = _c[1];
            }
            if (config.siblingRows.length > 0) {
                siblingTableData.push(promise_tracking_logic_1.PromiseTrackingTable.makeTableData(config.siblingRows, args.compareToNode.name));
            }
            mainTableData.push(promise_tracking_logic_1.PromiseTrackingTable.makeForecastTableData(config.forecastRows, args.nodeName, years));
            if (config.siblingForecastRows.length > 0) {
                siblingTableData.push(promise_tracking_logic_1.PromiseTrackingTable.makeForecastTableData(config.siblingForecastRows, args.compareToNode.name, years));
            }
        }
        else {
            var groups = Object.keys(config.forecastRows);
            _d = this.getColHeadersAndYears(groups, config, colHeaders, years), colHeaders = _d[0], years = _d[1];
            for (var i = 0; i < groups.length; i++) {
                var suffix = ' (' + groups[i] + ')';
                if (config.mainRows[groups[i]].length > 0) {
                    mainTableData.push(promise_tracking_logic_1.PromiseTrackingTable.makeTableData(config.mainRows[groups[i]], args.nodeName + suffix));
                }
                if (config.siblingRows && groups[i] in config.siblingRows
                    && config.siblingRows[groups[i]].length > 0) {
                    siblingTableData.push(promise_tracking_logic_1.PromiseTrackingTable.makeTableData(config.siblingRows[groups[i]], args.compareToNode.name + suffix));
                }
                if (config.forecastRows[groups[i]].length > 0) {
                    mainTableData.push(promise_tracking_logic_1.PromiseTrackingTable.makeForecastTableData(config.forecastRows[groups[i]], args.nodeName + suffix, years));
                }
                if (config.siblingForecastRows && groups[i] in config.siblingForecastRows
                    && config.siblingForecastRows[groups[i]].length > 0) {
                    siblingTableData.push(promise_tracking_logic_1.PromiseTrackingTable.makeForecastTableData(config.siblingForecastRows[groups[i]], args.compareToNode.name + suffix, years));
                }
            }
        }
        ctrl.tableData = {
            years: colHeaders,
            main: mainTableData,
            sibling: siblingTableData
        };
    };
    PromiseTrackingComponent.prototype.getColHeadersAndYears = function (groups, config, colHeaders, years) {
        var _a, _b, _c;
        var colHeaderFromForecast = false;
        for (var i = 0; i < groups.length; i++) {
            if (config.mainRows[groups[i]].length > 0) {
                if (colHeaders.length == 0 || (colHeaders.length > 0 && colHeaderFromForecast)) {
                    _a = promise_tracking_logic_1.PromiseTrackingTable.makeColHeader(config.mainRows[groups[i]]), colHeaders = _a[0], years = _a[1];
                    colHeaderFromForecast = false;
                    break;
                }
            }
            if (config.siblingRows && groups[i] in config.siblingRows
                && config.siblingRows[groups[i]].length > 0) {
                if (colHeaders.length == 0 || (colHeaders.length > 0 && colHeaderFromForecast)) {
                    _b = promise_tracking_logic_1.PromiseTrackingTable.makeColHeader(config.siblingRows[groups[i]]), colHeaders = _b[0], years = _b[1];
                    colHeaderFromForecast = false;
                    break;
                }
            }
            if (config.forecastRows[groups[i]].length > 0) {
                if (colHeaders.length == 0) {
                    _c = promise_tracking_logic_1.PromiseTrackingTable.makeColHeader(config.forecastRows[groups[i]]), colHeaders = _c[0], years = _c[1];
                    colHeaderFromForecast = true;
                }
            }
        }
        return [colHeaders, years];
    };
    PromiseTrackingComponent.prototype.getChartOptions = function (graph, options) {
        return promise_tracking_chart_1.getChartOptions(graph, options);
    };
    PromiseTrackingComponent.prototype.addPromiseConfigToMenu = function () {
        var ctrl = this;
        var promiseConfigMenu = {
            'name': 'Set Promise',
            'class': 'btn btn-xs btn-primary',
            'show': function () {
                return true;
            },
            'callback': function () {
                var rootNode = ctrl.currentNode.getRootNode();
                ctrl.$scope.$broadcast('promise-tracking:config', {
                    treeID: rootNode.name,
                    subTreeNameList: rootNode.children.map(function (c) { return ({ _id: c._id, name: c.name }); })
                });
            }
        };
        ctrl.menu.unshift(promiseConfigMenu);
    };
    PromiseTrackingComponent = __decorate([
        basic_chart_component_1.Component({
            bindings: {
                smartorgApi: '=',
                menu: '='
            },
            template: require("./promise-tracking.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], PromiseTrackingComponent);
    return PromiseTrackingComponent;
}(basic_chart_component_1.BasicChartComponent));
exports.PromiseTrackingComponent = PromiseTrackingComponent;
angular.module('smartorg.r6.acts.promiseTracking', [
    require('./promise-config/promise-config.component'),
]).component('promiseTracking', PromiseTrackingComponent);
module.exports = 'smartorg.r6.acts.promiseTracking';
//# sourceMappingURL=promise-tracking.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/promise-tracking/promise-tracking.component.js